import { render, staticRenderFns } from "./DeviceEdit.vue?vue&type=template&id=0460c61e"
import script from "./DeviceEdit.vue?vue&type=script&lang=ts"
export * from "./DeviceEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports